export const PROMO_COLORS = {
  safe: "#2e7d32",
  threat: "#d10000",
  warning: "#f58327",
  accentMain: "#b60002",
  accentLight: "#fbc210",
};
